<template>
    <el-container class="healthy page-x" direction="vertical">
        <drag-dialog title="视频医生服务详情" v-model="dialogVisible">
            <div class="dialog-list">
                <div class="title">基本信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{ dialogData.rightsUserName }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">性别：</div>
                    <div class="dialog-list-text">
                        <span v-if="dialogData.gender">{{
                                dialogData.gender == '1' ? '男' : '女'
                        }}</span>
                    </div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">年龄：</div>
                    <div class="dialog-list-text">{{ dialogData.age }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{ dialogData.mobile }}</div>
                </div>
                <div class="title">咨询记录</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询时间：</div>
                    <div class="dialog-list-text">{{ dialogData.beginTime }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询时长：</div>
                    <div class="dialog-list-text">{{ dialogData.consultTimes }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">分科：</div>
                    <div class="dialog-list-text">{{ dialogData.department }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">医生：</div>
                    <div class="dialog-list-text">{{ dialogData.doctor }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">主诉：</div>
                    <div class="dialog-list-text">{{ dialogData.demand }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">现病史：</div>
                    <div class="dialog-list-text">{{ dialogData.diseaseNow }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">既往史：</div>
                    <div class="dialog-list-text">{{ dialogData.diseaseHistory }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">家族史：</div>
                    <div class="dialog-list-text">{{ dialogData.familyDiseaseHistory }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">过敏史：</div>
                    <div class="dialog-list-text">{{ dialogData.allergyHistory }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">总结：</div>
                    <div class="dialog-list-text">{{ dialogData.doctorConclusion }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">药品信息：</div>
                    <div class="medicine" v-if="dialogData.medicine && dialogData.medicine.length">
                        <div class="medicine-list" v-for="(medicine,index) in dialogData.medicine" :key="index">
                        <div class="hr" v-if="index !== 0" />
                            <div class="medicine-list-box">
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">商品名称：</span>
                                    <span class="medicine-list-text">{{ medicine.medicineName }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">通用名：</span>
                                    <span class="medicine-list-text">{{ medicine.commonName }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">处方药：</span>
                                    <span class="medicine-list-text">{{ medicine.prescriptionDrugs == 1 ? '是' : '否' }}</span>
                                </div>
                            </div>
                            <div class="medicine-list-box">
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">厂商：</span>
                                    <span class="medicine-list-text">{{ medicine.vendor }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">规格：</span>
                                    <span class="medicine-list-text">{{ medicine.specification }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">价格：</span>
                                    <span class="medicine-list-text">{{ medicine.price }}</span>
                                </div>
                            </div>
                            <div class="medicine-list-box">
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">用法用量：</span>
                                    <span class="medicine-list-text">{{ medicine.usage }}</span>
                                </div>
                            </div>
                            <div class="medicine-list-box">
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">数量：</span>
                                    <span class="medicine-list-text">{{ medicine.number }}</span>
                                </div>
                            </div>
                            <div class="medicine-list-box">
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">药品订单号：</span>
                                    <span class="medicine-list-text">{{ medicine.medicineOrderCode }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">三方药品ID：</span>
                                    <span class="medicine-list-text">{{ medicine.medicineThirdId }}</span>
                                </div>
                                <div class="medicine-list-value">
                                    <span class="medicine-list-title">店铺ID：</span>
                                    <span class="medicine-list-text">{{ medicine.storeId }}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{ dialogData.userEvaluation }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation, operation } from "@/assets/js/options";
import { dateFormat } from "@/assets/js/until.js";
export default {
    name: "healthy",
    components: { dragDialog },
    data() {
        return {
            cardType, // 证件类型list
            orderState, // 订单状态list
            relation, // 与权益人关系list
            operation, // 操作list
            // table表格
            loading: false,
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
        };
    },
    methods: {
        /**
         * 显示弹窗
         */
        async showDetail(id) {
            // 清空状态
            this.dialogData = {}
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            let res = await this.axios.get(this.getApiUrl("videoDoctorOrderInfo"), {
                params: { id },
            });
            this.dialogData = res?.data || {};
            console.log(this.dialogData)
        },
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;

        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }

    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;

        .dialog-list-title {
            padding-left: 20px;
            width: 80px;
            white-space: nowrap;
            text-align: right;
        }

        .dialog-list-text {
            flex: 1;
        }
    }
}

.medicine {
    width: 100%;
    border: 1px solid #cccccc;
    padding-bottom: 15px;
    padding-left: 20px;
    .medicine-list {
        padding-top: 10px;
        .hr {
            border-bottom: 1px solid #cccccc;
            margin: 10px 20px 10px 0;
        }
        .medicine-list-box {
            display: flex;
            padding-top: 10px;

            .medicine-list-value {
                display: flex;
                flex: 1;
                align-items: center;
                .medicine-list-title {
                    width: 100px;
                    white-space: nowrap;
                    text-align: right;
                }
            }
        }
    }
}
</style>